import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import Sidebar from "../sidebar";
import Header from "../header";
import Footer from "../footer";
import { DOC } from "../../../constants/componentConstants";
import { useSelector } from "react-redux";
import "./layoutStyle.scss";
import { directLoginStorage } from "../../../utils/storageHelper";
const { Content } = Layout;

const LayoutView = ({ children }) => {
  let accessToken = localStorage.getItem("accessToken") || localStorage.getItem("wsmAccessToken");
  const currentUrl = window?.location?.href;
  const { isVMExtended } = useSelector(({ layout }) => layout);
  const { sidebarHidden } = useSelector(({ common }) => common);

  const [showLayout, setShowLayout] = useState(
    (accessToken && (sessionStorage.getItem("wsDetails") || sessionStorage.getItem("portDetails"))) || false
  );
  const { idpAuthToken, localUserTokenData, authTokenSuccess, workspaceLoginSuccess } = useSelector(
    ({ userAuthentication }) => userAuthentication
  );
  const { workspaceAuthResponse } = useSelector(({ workspaceManager }) => workspaceManager);

  let sideMenu = "";
  if (currentUrl?.includes(`/${DOC}`)) {
    sideMenu = null;
  } else if (currentUrl?.includes("ws")) {
    sideMenu = null;
  } else if (directLoginStorage.get("isDemandLogin") || window.location.href.includes("odl")) {
    sideMenu = null;
  } else if (currentUrl?.toLowerCase().includes("dashboard-vm") || currentUrl?.toLowerCase().includes("dashboard-cloud")) {
    sideMenu = null;
  } else if (sidebarHidden) {
    sideMenu = null;
  } else {
    sideMenu = <Sidebar></Sidebar>;
  }

  useEffect(() => {
    if (
      idpAuthToken?.status === 200 ||
      localUserTokenData?.status === 200 ||
      authTokenSuccess?.status === 200 ||
      workspaceLoginSuccess?.status === 200 ||
      workspaceAuthResponse?.status === 200
    ) {
      setShowLayout(true);
    }
  }, [idpAuthToken, localUserTokenData, authTokenSuccess, workspaceLoginSuccess, workspaceAuthResponse]);

  useEffect(() => {
    if (accessToken) {
      setShowLayout(true);
    }
  }, []);

  return (
    <>
      {showLayout ? (
        <>
          <Layout className="layout-height-min">
            {!isVMExtended && !sidebarHidden && <Header></Header>}
            <Layout>
              {sideMenu}
              <Layout className={sidebarHidden ? "" : "page-layout"}>
                <Content className={`site-layout-background ${sidebarHidden ? "" : "content-adjust"}`}>
                  {children}
                </Content>
                {!isVMExtended && !sidebarHidden && <Footer></Footer>}
              </Layout>
            </Layout>
          </Layout>
        </>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default LayoutView;
